import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2103a99e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information-block" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "key" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_title = _resolveComponent("base-title")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_title, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.block.title), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_base_card, { class: "information" }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.block.fields, (field) => {
            return (_openBlock(), _createElementBlock("li", {
              key: field.key
            }, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(field.key), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.formatValue(field)), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
}